/* eslint-disable no-underscore-dangle */

const ALLOWED_WORKSPACES = (window as any)._env_.REACT_APP_ALLOWED_WORKSPACES?.split(',') || ['FMI_test', 'TimeSerieExample'];

export default ALLOWED_WORKSPACES;
